var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","open-delay":200,"placement":_vm.isPosition},scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('div',{style:({ maxWidth: _vm.popMaxWidthPx })},[_vm._t("content",function(){return [(_vm.tips)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.tips)}}):_vm._e()]})],2)]},proxy:true}],null,true)},[(!_vm.tipsFlag)?_c('span',[_vm._v(_vm._s(_vm.tipsLabel))]):_vm._e(),(_vm.tipsFlag)?_c('i',{staticClass:"icon-item",class:_vm.iconClass,style:({
      position: _vm.position,
      fontSize: _vm.fontS + 'px',
      color: _vm.color,
      fontWeight: 400,
    })}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }